"use strict";

var _defineProperty2 = require("/vercel/path1/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var styles = {};
styles.wrapper = {
  display: "inline-block",
  boxSizing: "border-box",
  maxWidth: "100%",
  minWidth: "100px",
  overflow: "hidden",
  textAlign: "left",
  verticalAlign: "bottom"
};
styles.wrapperDefault = _objectSpread(_objectSpread({}, styles.wrapper), {}, {
  border: "1px solid #ccc",
  backgroundColor: "white"
});
styles.innerWrapper = {
  display: "inline-block",
  overflowX: "scroll",
  overflowY: "hidden",
  position: "relative",
  width: "100%"
}; // Common style fro input and placeholder

var inputCommon = {
  fontSize: "16px",
  fontFamily: "sans-serif",
  boxSizing: "border-box",
  borderWidth: "0",
  // Stretch to fill wrapper
  minWidth: "100%",
  margin: "0"
};
styles.input = _objectSpread(_objectSpread({}, inputCommon), {}, {
  position: "relative",
  zIndex: 1,
  padding: "5px 6px",
  outline: "none",
  caretColor: "black",
  // Make transparent background and font to make placeholder visible
  lineHeight: "22px",
  backgroundColor: "transparent",
  color: "rgba(0,0,0,0)"
});
styles.stub = {
  display: "block",
  position: "fixed",
  left: "-10000px",
  opacity: 0,
  whiteSpace: "pre"
};
styles.placeholder = _objectSpread(_objectSpread({}, inputCommon), {}, {
  padding: "6px",
  lineHeight: "22px",
  // Make movable
  position: "absolute",
  // Move below input
  zIndex: 0,
  top: 0,
  left: 0,
  display: "block",
  // Turn off double scrolling.
  overflow: "hidden",
  // Set whitespace wrapping the same as input has.
  whiteSpace: "pre"
});
var scrollbar = getScrollbarSize(); // Input Data is using to allow filter and update functions be always optimized

var InputData = function InputData(inputType, data, selectionStart, selectionEnd) {
  _classCallCheck(this, InputData);

  this.inputType = inputType;
  this.data = data;
  this.selectionStart = selectionStart;
  this.selectionEnd = selectionEnd === undefined ? selectionStart : selectionEnd;
};

var MightyInput = /*#__PURE__*/function (_React$Component) {
  _inherits(MightyInput, _React$Component);

  function MightyInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MightyInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MightyInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: "",
      focus: false,
      input: new InputData()
    });

    _defineProperty(_assertThisInitialized(_this), "wrapperRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "inWrapperRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "placeholderRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "inputRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "stubRef", _react.default.createRef());

    return _this;
  }

  _createClass(MightyInput, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setState({
        value: this.props.value || ""
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(props, state) {
      if (props.value === this.props.value && state.value === this.state.value && state.focus === this.state.focus && this.props.render === props.render && this.props.filter === props.filter && this.props.onUpdate === props.onUpdate && this.props.onChange === props.onChange && this.props.modifiers === props.modifiers) {
        return false;
      }

      if (props.value !== this.props.value) {
        this.setState({
          value: props.value
        });
      }

      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var stubEl = this.stubEl,
          inputEl = this.inputEl,
          placeholderEl = this.placeholderEl,
          wrapperEl = this.wrapperEl,
          inWrapperEl = this.inWrapperEl;
      var style = window.getComputedStyle(this.inputEl);
      stubEl.style.paddingTop = style.paddingTop;
      stubEl.style.paddingBottom = style.paddingBottom;
      stubEl.style.paddingRight = style.paddingRight;
      stubEl.style.paddingLeft = style.paddingLeft;
      stubEl.style.border = style.border;
      stubEl.style.fontFamily = style.fontFamily;
      stubEl.style.fontSize = style.fontSize; // Resize wrapper and inner wrapper to hide scrollbars

      wrapperEl.style.height = placeholderEl.offsetHeight + "px";
      inWrapperEl.style.height = inputEl.offsetHeight + (scrollbar.height || 20) + "px";
      inputEl.addEventListener("beforeinput", function (e) {
        _this2.setState({
          input: new InputData(e.inputType, e.data, inputEl.selectionStart, inputEl.selectionend)
        });
      });
      this.updateWidth();
    }
  }, {
    key: "setFocus",
    value: function setFocus() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.state.focus === flag) {
        return;
      }

      this.setState({
        focus: flag
      });
    }
  }, {
    key: "onInput",
    value: function onInput(e) {
      var _this$state = this.state,
          value = _this$state.value,
          input = _this$state.input;
      var filter = this.props.filter;
      var newValue = filter(e.target.value, value, input);
      this.setState({
        value: newValue,
        input: new InputData()
      });
      this.updateWidth();

      if (value !== newValue) {
        this.props.onUpdate(newValue, value, input);
      }
    }
  }, {
    key: "updateWidth",
    value: function updateWidth() {
      this.stubEl.textContent = this.state.value;
      this.placeholderEl.style.width = this.inputEl.style.width = 2 + this.stubEl.offsetWidth + "px";
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          render = _this$props.render,
          filter = _this$props.filter,
          className = _this$props.className,
          onUpdate = _this$props.onUpdate,
          onChange = _this$props.onChange,
          style = _this$props.style,
          modifiers = _this$props.modifiers,
          props = _objectWithoutProperties(_this$props, ["render", "filter", "className", "onUpdate", "onChange", "style", "modifiers"]);

      var _this$state2 = this.state,
          value = _this$state2.value,
          focus = _this$state2.focus;
      var classes = [];
      var wrapperStyle;

      if (className) {
        classes.push(className);
        wrapperStyle = styles.wrapper;
      } else {
        wrapperStyle = styles.wrapperDefault;
      }

      if (focus) {
        classes.push(modifiers.focus);
      }

      return _react.default.createElement("span", {
        ref: this.wrapperRef,
        className: classes.join(" "),
        style: wrapperStyle
      }, _react.default.createElement("span", {
        ref: this.inWrapperRef,
        style: styles.innerWrapper
      }, _react.default.createElement("input", _extends({
        onChange: onChange
      }, props, {
        style: styles.input,
        ref: this.inputRef,
        onInput: function onInput(e) {
          return _this3.onInput(e);
        },
        onFocus: function onFocus() {
          _this3.setFocus(true);
        },
        onBlur: function onBlur() {
          _this3.setFocus(false);
        },
        value: value
      })), _react.default.createElement("span", {
        "aria-hidden": true,
        style: styles.placeholder,
        ref: this.placeholderRef
      }, render(value) || "\u200B"), _react.default.createElement("span", {
        "aria-hidden": true,
        ref: this.stubRef,
        style: styles.stub
      })));
    }
  }, {
    key: "wrapperEl",
    get: function get() {
      return this.wrapperRef.current;
    }
  }, {
    key: "inWrapperEl",
    get: function get() {
      return this.inWrapperRef.current;
    }
  }, {
    key: "inputEl",
    get: function get() {
      return this.inputRef.current;
    }
  }, {
    key: "placeholderEl",
    get: function get() {
      return this.placeholderRef.current;
    }
  }, {
    key: "stubEl",
    get: function get() {
      return this.stubRef.current;
    }
  }]);

  return MightyInput;
}(_react.default.Component);

exports.default = MightyInput;

_defineProperty(MightyInput, "defaultProps", {
  filter: function filter(v) {
    return v;
  },
  render: function render(v) {
    return v;
  },
  onChange: function onChange() {},
  onUpdate: function onUpdate() {},
  modifiers: {
    focus: "--focus"
  }
});

function getScrollbarSize() {
  var root = document.createElement("div");
  root.style.position = "absolute";
  root.style.top = "-100px";
  var outer = document.createElement("div");
  outer.style.position = "relative";
  outer.style.width = "100px";
  outer.style.height = "100px";
  outer.style.overflow = "scroll";
  var inner = document.createElement("div");
  inner.style.position = "absolute";
  inner.style.top = "0px";
  inner.style.bottom = "0px";
  inner.style.right = "0px";
  inner.style.left = "0px";
  outer.appendChild(inner);
  root.appendChild(outer);
  document.body.appendChild(root);
  var width = outer.offsetWidth - inner.offsetWidth;
  var height = outer.offsetHeight - inner.offsetHeight;
  document.body.removeChild(root);
  return {
    width: width,
    height: height
  };
}